import domReady from '@wordpress/dom-ready';

domReady(() => {
  const btnsPDF = document.querySelectorAll(
    '.wp-block-button.is-style-pdf-link .wp-element-button'
  );

  if (btnsPDF) {
    btnsPDF.forEach((buttonPDF) => {
      buttonPDF.innerHTML =
        '<i class="icomoon-icon icon-download" aria-hidden="true"></i>' +
        buttonPDF.innerHTML;
    });
  }

  const btnsExternalLink = document.querySelectorAll(
    '.wp-block-button.is-style-external-link .wp-element-button'
  );

  if (btnsExternalLink) {
    btnsExternalLink.forEach((buttonExternalLink) => {
      buttonExternalLink.innerHTML =
        '<i class="icomoon-icon icon-External" aria-hidden="true"></i>' +
        buttonExternalLink.innerHTML;
    });
  }
});
